import { IBookAChat, IBookAMeeting} from '@app-types/websocket/expert.types';
import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

export function bookMeeting(data: IBookAMeeting) {

  socket.sendJSON({
    bookAMeeting: data,
  });
}

export function bookChat(data: IBookAChat) {

  socket.sendJSON({
    bookAChat: data,
  });
}




// WEBPACK FOOTER //
// ./src/services/expert/expert.websocket.ts